var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-main"},[_c('div',{staticClass:"leftBlock"},[_c('leftBlock')],1),_c('div',{staticClass:"rightBlock"},[_c('rightBlock')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }